module.exports = __webpack_public_path__ + "static/media/logo-mini.f54f105e.svg";